export enum Policy {
	NoOne = 'NoOne',
	UsersOnly = 'UsersOnly',
	Everyone = 'Everyone',
}

export enum KeepOriginalDocument {
	Allow = 'pages.settings.allowKeepOriginalDocument',
	NotAllow = 'pages.settings.notAllowKeepOriginalDocument',
}

export interface IKeepOriginalDocument {
	value: 0 | 1;
	label: KeepOriginalDocument;
}
